import { ComponentRef } from '@angular/core';
import { TemplateContext } from '../../../../models/reportTemplate.model';
import { CHAIN_OF_CUSTODY_SAMPLE_TABLE } from '../../../../common-components/generate-coc-popup/chain-of-custody-default-template.constants';
import { EditorPropertySchema, EditorRenderStrategy } from '../../sample-widgets/widget-config.helpers';
import { CocSampleTableWidgetComponent } from './coc-sample-table-widget.component';

export function configureCocSampleTableWidget(
    componentRef: ComponentRef<unknown>,
    context: TemplateContext
): void {
    (componentRef.instance as CocSampleTableWidgetComponent).context = context;
}

export const cocSampleTableLoopTemplate = CHAIN_OF_CUSTODY_SAMPLE_TABLE;

export const cocSampleTableLoopScopes: { loopExpr: string; label: string; fields: string[] }[] = [
    {
        loopExpr: 'samples',
        label: 'Per Sample',
        fields: [
            'sampleNumber', 'alternateSampleNumber', 'agentNames', 'agentGroupName', 'agentGroupCasId', 'samplingDate', 'volumeLiters',
            'runTimeMinutes', 'flowRateFormatted', 'analyticalMethodName', 'categoryName', 'employeeName', 'taskNames', 'equipment', 'barcodeContent'
        ]
    },
    {
        loopExpr: 'this.labResults',
        label: 'Per Lab Result',
        fields: [
            'agentName', 'agentCasId', 'agentGroupName', 'result', 'resultValue', 'censor', 'units', 'loq', 'labSampleId', 'mass', 'twa',
            'jurisdictionName', 'oelTypeName', 'methodName'
        ]
    }
];

export const cocSampleTableEditorPropertySchema: EditorPropertySchema = {
    renderStrategy: EditorRenderStrategy.ReadOnly,
    propertySchema: []
};
